import { AxiosError } from 'axios'

export default function (error: AxiosError | Error): string {
  if (!error) return ''
  // @ts-ignore
  return error.response?.data?.message || error.response?.data?.toString() || error.toString()
}
